import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse } from "axios";

export abstract class IBodyshopTypeApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
